import { verifyTechnician } from 'services/pod';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IVerifyTechPayload } from 'services/pod/types';

export const ThunkVerifyTechnician = createAsyncThunk<any, IVerifyTechPayload>(
  'pod/verifyTechnician',
  async payload => {
    const r = await verifyTechnician(payload);
    return r.data;
  },
);
